import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import Marker from "./Marker";

import "./style.scss";

// Set Zoom
const setZoom = map => {
  let zoomOverride = map.getZoom();
  if (zoomOverride > 15) {
    zoomOverride = 15;
  }
  return map.setZoom(zoomOverride);
};

// Return map bounds based on list of listing
const getMapBounds = (map, maps, place) => {
  const bounds = new maps.LatLngBounds();
  bounds.extend(new maps.LatLng(place.location.lat, place.location.lng));
  setZoom(map);
  return bounds;
};

// Re-center map when resizing the window
const bindResizeListener = (map, maps, bounds) => {
  maps.event.addDomListenerOnce(map, "idle", () => {
    maps.event.addDomListener(window, "resize", () => {
      map.fitBounds(bounds);
      setZoom(map);
    });
  });
};

// Fit map to its bounds after the api is loaded
const handleApiLoaded = (map, maps, listing) => {
  // Get bounds by our listing
  const bounds = getMapBounds(map, maps, listing);
  // Fit map to bounds
  map.fitBounds(bounds);
  // Set Zoom
  setZoom(map);
  // Bind the resize listener
  bindResizeListener(map, maps, bounds);
};

class SingleMap extends Component {
  static defaultProps = {
    center: {
      lat: 11.9416,
      lng: 79.8083
    },
    zoom: 15
  };

  render() {
    let { listing, priceCalculation } = this.props;
    return (
      <GoogleMapReact
        bootstrapURLKeys={{
          key: "AIzaSyD3Uu4Ib-bl3A8Tbf3RLacBc1PjCNOcn0k"
        }}
        center={this.props.center}
        zoom={this.props.zoom}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps }) =>
          handleApiLoaded(map, maps, listing)
        }
        options={{ streetViewControl: true }}
      >
        <Marker
          key={listing.id}
          lat={listing.location.lat}
          lng={listing.location.lng}
          show={true}
          place={listing}
          price={
            priceCalculation === "unset"
              ? listing.address
              : priceCalculation(listing.price)
          }
        />
      </GoogleMapReact>
    );
  }
}

export default SingleMap;
